<template>
  <div class="charges-tab">
    <div class="charges-tab-data-table w-6">
      <h2 class="section-subheader">{{ t('rateShop.charges.charges', 2) }}</h2>
      <DataTable
        :value="charges"
        class="rate-detail-table p-datatable-sm"
        table-style="min-width: 20rem"
      >
        <Column :header="t('rateShop.charges.code')" field="code" class="w-1">
          <template #body="{ data }">
            {{ data.code }}

            <div
              v-if="
                data.description &&
                lowerCase(data.code) !== lowerCase(data.description)
              "
              class="text-gray-darker sub-heading"
            >
              {{ data.description }}
            </div>
          </template>
        </Column>

        <Column
          :header="t('rateShop.charges.stop')"
          field="stopSequenceNumber"
          class="w-1"
        >
          <template #body="{ data }">
            <StopSequenceNumberTooltip :data="data" />
          </template>
        </Column>

        <Column :header="t('rateShop.charges.amount')" class="w-1 text-right">
          <template #body="{ data: rateQuoteCharge }">
            <div class="text-right">
              {{
                renderMoney(rateQuoteCharge.charge, {
                  currencyCode: rateQuote.currencyCode,
                })
              }}
            </div>
          </template>
          <template #footer>
            <div class="text-right text-success font-medium">
              {{
                renderMoney(rateQuote.totalPrice, {
                  currencyCode: rateQuote.currencyCode,
                })
              }}
            </div>
          </template>
        </Column>
      </DataTable>
    </div>

    <div class="quote-details w-6">
      <RateQuoteDetails :rate-quote="rateQuote" :email-tender="emailTender" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useFlag } from '@unleash/proxy-client-vue';
import { computed, toRefs } from 'vue';
import { useI18n } from 'vue-i18n';

import { lowerCase, renderMoney } from '@rygen/rygen-ui/i18n';

import { RateQuote } from '@/model';

import RateQuoteDetails from '@/components/rateShop/expandedDetails/RateQuoteDetails.vue';
import StopSequenceNumberTooltip from '@/components/rateShop/expandedDetails/StopSequenceNumberTooltip.vue';
import Column from 'primevue/column';
import DataTable from 'primevue/datatable';

const props = defineProps({
  rateQuote: {
    type: RateQuote,
    default: () => new RateQuote(),
  },
  emailTender: {
    type: Boolean,
    default: () => false,
  },
});
const { rateQuote, emailTender } = toRefs(props);

const arApFeatureFlagEnabled = useFlag('ar-ap-split-feat-flag');
const { t } = useI18n();

const charges = computed(() =>
  arApFeatureFlagEnabled.value
    ? rateQuote.value.chargesRedesign
    : rateQuote.value.charges,
);
</script>

<style>
.charges-tab {
  display: flex;
  gap: var(--sp-3);

  .quote-details {
    border-left: 1px solid var(--divider-color);
    padding-inline: var(--sp-3);
  }
}
</style>
